import TonalButton from '@/components/TonalButton';
import styled from '@emotion/styled';

const StyledTasksButton = styled(TonalButton)({
  marginLeft: 12,
  paddingLeft: 16,
  paddingRight: 16,
  height: 40,
});

export default StyledTasksButton;
